import { Box } from "@chakra-ui/react";
import { Card } from "./Card";

interface DataCardProps {
  data: { [key: string]: string | number | null };
}

export const DataCard = ({ data }: DataCardProps) => {
  return (
    <Card
      display={"flex"}
      flexDir={"column"}
      width={"100%"}
      padding={2}
      marginTop={2}
    >
      {Object.entries(data).map(([k, v]) => (
        <Card display={"flex"} key={k} padding={2} marginBottom={1}>
          <Box fontWeight={"bold"} marginRight={2}>
            {k}
          </Box>
          <Box wordBreak={"break-all"}>{v}</Box>
        </Card>
      ))}
    </Card>
  );
};
